import { filter } from "lodash";
import React, { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Box, Flex } from "rebass";
import useResponsive from "../../hooks/useResponsive";
import ChevronDown from "../../icons/ChevronDown";
import Close from "../../icons/Close";
import Gallery from "../../icons/Gallery";
import HangerBG from "../../icons/HangerBG";
import { yodaOrdersActions } from "../../logic/actions";
import { getLocalizedString } from "../../utils";
import config from "../../utils/globalConfig";
import sizeSort from "../../utils/sizeSort";
import AvailabilityGridDoor from "../availability/AvailabilityGridDoor";
import { ColorTooltip } from "../common/ColorTooltip";
import { Price } from "../common/Price";
import { ProductImage } from "../common/ProductImage";
import Tooltip from "../common/Tooltip";
import { PopupImages } from "../product/PopupImages";
import TableSize from "../product/TableSize";
import MobileOrderDetailSwap from "./MobileOrderDetailSwap";
import OrderDetailInfo from "./OrderDetailInfo";
import OrderDetailTotal from "./OrderDetailTotal";
import { ToastMessage } from "./ToastMessage";
const OrderDetailSwap = ({
  id,
  modelCode,
  collectionCode,
  line,
  collection,
  totalQuantityColorMap,
  expandAll,
  callbackRemoved,
  images,
}) => {
  const lang = localStorage.getItem("B2BLanguage") === "ITA" ? "it" : "en";

  const { catalogueItemDetailsSwap } = useSelector(
    (state) => state.yodaCatalogue,
  );
  const { orderRowDetails, order, configuration } = useSelector(
    (state) => state.yodaOrders,
  );

  const { isMobile, isTablet, isDesktop } = useResponsive();

  const { customer } = useSelector((state) => state.yodaCustomer);
  const { me } = useSelector((state) => state.yodaStakeholders);

  const [forceVisible, setForceVisible] = useState({});
  const [sessionAddedColors, setSessionAddedColors] = useState([]);

  const [expanded, setExpanded] = useState(1);
  const [deleteMessage, setDeleteMessage] = useState();
  const [removeProduct, setRemoveProduct] = useState(false);
  const [colorCode, setColorCode] = useState();
  const [popupImages, setPopupImages] = useState(false);
  const [mModelCode, setMModelCode] = useState();
  const [showDetails, setShowDetails] = useState(false);

  const [showNumPad, setShowNumPad] = useState(false);
  const [buttonTableView, setButtonTableView] = useState(false);
  const [tableView, setTableView] = useState(false);
  const changeTableView = () => {
    setTableView(!tableView);
  };

  useEffect(() => {
    if (id) setButtonTableView(catalogueItemDetailsSwap[id]?.findSizes);
  }, [catalogueItemDetailsSwap]);

  const { imagedefault, rotationdefault } = useMemo(
    () => catalogueItemDetailsSwap?.[id] || {},
    [catalogueItemDetailsSwap, id],
  );

  const sortColors = (colors) => {
    if (!Array.isArray(colors)) return [];
    const sorted = [...colors];
    return sorted.sort((a, b) => {
      const indexA = sessionAddedColors.findIndex((color) => color === a.code);
      const indexB = sessionAddedColors.findIndex((color) => color === b.code);
      if (indexA > -1 && indexB > -1) {
        return indexB - indexA;
      } else if (indexA > -1) {
        return -1;
      } else if (indexB > -1) {
        return 1;
      } else return 0;
    });
  };

  useEffect(() => {
    setForceVisible({ ...forceVisible, ...totalQuantityColorMap });
  }, []);

  useEffect(() => {
    setTimeout(() => {
      setShowNumPad(true);
    }, 400);
  }, []);

  const dispatch = useDispatch();

  useEffect(() => {
    expandAll ? setShowDetails(true) : setShowDetails(false);
  }, [expandAll]);

  const availabilityColorsMap = {
    green: "#249d4e",
    yellow: "#cea418",
    red: "#f04836",
  };

  function calculatedColors() {
    let tmpArr = {};
    catalogueItemDetailsSwap[id]?.catalog?.map((e) => {
      if (tmpArr[e.colorCode] === undefined) {
        tmpArr[e.colorCode] = {
          colorDescription: e.colorDescription?.[lang] || "",
          rgb: e.rgb,
          code: e.colorCode,
          catalogId: e.catalogId,
          values: [
            {
              size: e.size,
              sizeCode: e.sizeRowId,
              quantity: e.quantity,
            },
          ],
        };
      } else {
        tmpArr[e.colorCode].values.push({
          size: e.size,
          sizeCode: e.sizeRowId,
          quantity: e.quantity,
        });
      }
    });

    if (tmpArr === undefined) {
      return [];
    }

    let tmpArr2 = Object.keys(tmpArr).map(function (key) {
      return tmpArr[key];
    });

    return Array.from(tmpArr2);
  }

  let totalQuantity = 0;
  let totalPrice = 0;

  let totalQuantityC = {};
  let totalPriceC = {};

  let totalQuantityD = {};
  let totalPriceD = {};

  calculatedColors().map((e, index) => {
    order &&
      order?.customData?.doors &&
      order.customData.doors.map((d, idx) => {
        let catalogId = e.catalogId;

        let tmpArr = filter(
          orderRowDetails,
          (orderRow, v) =>
            orderRow.catalogId == catalogId &&
            d == orderRow.customData.doorId &&
            orderRow?.customData?.typeId === config.ORDER_TYPE_SWAP,
        );

        tmpArr?.forEach((e1) => {
          totalQuantity += e1.currentQuantity;
          totalPrice += e1.price;

          if (totalQuantityC[e.code] == undefined) {
            totalQuantityC[e.code] = e1.currentQuantity;
          } else {
            totalQuantityC[e.code] += e1.currentQuantity;
          }

          if (totalPriceC[e.code] == undefined) {
            totalPriceC[e.code] = e1.price;
          } else {
            totalPriceC[e.code] += e1.price;
          }

          if (e1?.customData?.doorId == d) {
            if (totalQuantityD[d] == undefined) {
              totalQuantityD[d] = e1.currentQuantity;
            } else {
              totalQuantityD[d] += e1.currentQuantity;
            }

            if (totalPriceD[d] == undefined) {
              totalPriceD[d] = e1.price;
            } else {
              totalPriceD[d] += e1.price;
            }
          }
        });
      });
  });

  let displayableQuantityD = [];
  let displayableQuantityString = "";
  Object.keys(totalQuantityD).forEach((e) => {
    displayableQuantityD.push([e, totalQuantityD[e]]);
    displayableQuantityString += "30px 30px ";
  });

  function expand() {
    setExpanded(expanded == 0 ? 1 : 0);
  }

  function forceColorInvisibility(color) {
    let tmpMap = { ...forceVisible };
    tmpMap[color] = 0;
    setForceVisible(tmpMap);
    setSessionAddedColors(sessionAddedColors.filter((code) => code !== color));
  }

  function forceColorVisibility(color) {
    let tmpMap = { ...forceVisible };
    tmpMap[color] = 1;
    setForceVisible(tmpMap);
    setSessionAddedColors([...sessionAddedColors, color]);
  }

  function forceVisibleFromModal(code) {
    forceColorVisibility(code);
  }

  const click = (id, color, door, idx) => {
    const numericPad = document.getElementById(
      [id, color, door, idx].join("_"),
    );
    numericPad.click();
  };

  return expanded === 0 ? (
    isMobile ? (
      <MobileOrderDetailSwap
        id={id}
        modelCode={modelCode}
        previewImage={imagedefault}
        collectionCode={collectionCode}
        line={line}
        collection={collection}
        calculatedColors={calculatedColors()}
        sortColors={sortColors}
        forceVisible={forceVisible}
        forceColorVisibility={(color) => forceColorVisibility(color)}
        forceColorInvisibility={(color) => forceColorInvisibility(color)}
        forceVisibleFromModal={(code) => forceVisibleFromModal(code)}
        totalQuantityC={totalQuantityC}
        totalPriceC={totalPriceC}
        expandAll={expandAll}
        totalQuantity={totalQuantity}
        totalPrice={totalPrice}
        callbackRemoved={callbackRemoved}
        {...{ sessionAddedColors }}
      />
    ) : (
      <Flex
        onClick={expand}
        style={{ position: "relative", cursor: "pointer" }}
        minHeight={["330px", "0px"]}
        mt={3}
        w={1}
        maxWidth={config.VIEWPORT}
        bg={"#F2F2F2"}
        flexDirection={"column"}
        fontSize="0.8em"
      >
        <ToastMessage
          message={deleteMessage}
          needConfirm={true}
          confirmFunction={(ev) => {
            dispatch(
              yodaOrdersActions.removeProduct(
                order.id,
                config.ORDER_TYPE_SWAP,
                id,
                mModelCode,
                colorCode,
              ),
            );
            if (removeProduct) {
              callbackRemoved();
            }
            setDeleteMessage(null);
            setRemoveProduct(false);
            setColorCode(null);
            setMModelCode(null);
            if (colorCode) {
              forceColorInvisibility(colorCode);
            }
            ev.preventDefault();
            ev.stopPropagation();
            ev.nativeEvent.stopImmediatePropagation();
          }}
          cancelFunction={(ev) => {
            setDeleteMessage(null);
            setRemoveProduct(false);
            setColorCode(null);
            setMModelCode(null);
            ev.preventDefault();
            ev.stopPropagation();
            ev.nativeEvent.stopImmediatePropagation();
          }}
          style={{ width: 600 }}
        />
        <Flex>
          <Box
            sx={{
              position: "relative",
              width: "285.37px",
              paddingTop: "25px",
              paddingLeft: ["15px", , , "27.8585px"],
              paddingBottom: ["15px", , , "25px"],
              paddingRight: "27.8585px",
            }}
          >
            <ProductImage
              img={imagedefault}
              scale={"1.2"}
              width={"100%"}
              height={"140px"}
            ></ProductImage>
          </Box>
          <Flex
            flexDirection={"column"}
            sx={{
              height: "100%",
              width: "100%",
              paddingBottom: ["15px", , , "25px"],
              paddingRight: ["15px", , , "25px"],
            }}
          >
            <OrderDetailInfo
              {...{
                expand,
                modelCode,
                collectionCode,
                configuration,
                order,
                collection,
                line,
              }}
            />
            {isDesktop && (
              <OrderDetailTotal
                displayDoors
                {...{
                  displayableQuantityD,
                  customer,
                  totalQuantity,
                  totalPrice,
                }}
              />
            )}
          </Flex>
        </Flex>
        {isTablet && (
          <OrderDetailTotal
            displayDoors
            {...{ displayableQuantityD, customer, totalQuantity, totalPrice }}
            sx={{
              margin: "0 15px",
            }}
          />
        )}
        {/* BUTTONS */}
        <Tooltip content={getLocalizedString("ORDER_DELETE_ITEM")}>
          <Box
            sx={{ "& > svg > g > g > line": { stroke: "white" } }}
            style={{
              cursor: "pointer",
              position: "absolute",
              right: "15px",
              top: "10px",
              backgroundColor: "#232323",
              zIndex: 1,
            }}
            onClick={(evt) => {
              setMModelCode(modelCode);
              setDeleteMessage(
                getLocalizedString("DELETEORDER_ITEM_MESSAGE") +
                  modelCode +
                  " ?",
              );
              setRemoveProduct(true);
              evt.preventDefault();
              evt.stopPropagation();
              evt.nativeEvent.stopImmediatePropagation();
            }}
          >
            <Close style={{ width: 24, height: 24 }}></Close>
          </Box>
        </Tooltip>
        <Box
          onClick={expand}
          sx={{ "& > svg > g > g > line": { stroke: "white" } }}
          style={{
            cursor: "pointer",
            position: "absolute",
            right: "15px",
            top: "10px",
            backgroundColor: "#232323",
          }}
        >
          {expanded && (
            <Tooltip content={getLocalizedString("ORDER_COLLAPSE_ROW")}>
              <Box bg="#f2f2f2" style={{ position: "absolute", right: "40px" }}>
                <ChevronDown
                  className="checvron.exp_true"
                  style={{
                    transform: "rotate(180deg)",
                    width: 24,
                    height: 24,
                  }}
                />
              </Box>
            </Tooltip>
          )}

          {!expanded && (
            <Tooltip content={getLocalizedString("ORDER_EXPAND_ROW")}>
              <Box
                bg="#f2f2f2"
                style={{ position: "absolute", right: "40px", top: "0px" }}
              >
                <ChevronDown
                  className="checvron.exp_false"
                  style={{ width: 24, height: 24 }}
                />
              </Box>
            </Tooltip>
          )}
        </Box>
        {/* END - BUTTONS */}
      </Flex>
    )
  ) : isMobile ? (
    <MobileOrderDetailSwap
      id={id}
      modelCode={modelCode}
      previewImage={imagedefault}
      collectionCode={collectionCode}
      line={line}
      collection={collection}
      calculatedColors={calculatedColors()}
      sortColors={sortColors}
      forceVisible={forceVisible}
      forceColorVisibility={(color) => forceColorVisibility(color)}
      forceColorInvisibility={(color) => forceColorInvisibility(color)}
      forceVisibleFromModal={(code) => forceVisibleFromModal(code)}
      totalQuantityC={totalQuantityC}
      totalPriceC={totalPriceC}
      expandAll={expandAll}
      totalQuantity={totalQuantity}
      totalPrice={totalPrice}
      callbackRemoved={callbackRemoved}
      {...{ sessionAddedColors }}
    />
  ) : (
    <Flex
      style={{ position: "relative" }}
      mt={3}
      w={1}
      maxWidth={config.VIEWPORT}
      bg={"#F2F2F2"}
      flexDirection={["column", , , "row"]}
      fontSize={"0.8em"}
    >
      <ToastMessage
        message={deleteMessage}
        needConfirm={true}
        confirmFunction={(ev) => {
          dispatch(
            yodaOrdersActions.removeProduct(
              order.id,
              config.ORDER_TYPE_SWAP,
              id,
              mModelCode,
              colorCode,
            ),
          );
          if (removeProduct) {
            callbackRemoved();
          }
          setDeleteMessage(null);
          setRemoveProduct(false);
          setColorCode(null);
          setMModelCode(null);
          if (colorCode) {
            forceColorInvisibility(colorCode);
          }
          ev.preventDefault();
          ev.stopPropagation();
          ev.nativeEvent.stopImmediatePropagation();
        }}
        cancelFunction={(ev) => {
          setDeleteMessage(null);
          setRemoveProduct(false);
          setColorCode(null);
          setMModelCode(null);
          ev.preventDefault();
          ev.stopPropagation();
          ev.nativeEvent.stopImmediatePropagation();
        }}
        style={{ width: 600 }}
      />
      {/* PRODUCT IMAGE & COLORS */}
      <Box
        sx={{
          display: ["initial", "flex", , "initial"],
        }}
      >
        <Box
          sx={{
            position: "relative",
            width: ["50%", , , "340px"],
            paddingTop: "25px",
            paddingLeft: "15px",
            paddingBottom: [0, , , "25px"],
            paddingRight: "27.8585px",
          }}
        >
          <ProductImage
            img={imagedefault}
            scale={"1.2"}
            width={"100%"}
            height={"190px"}
          ></ProductImage>

          <Tooltip content={getLocalizedString("GALLERY")}>
            <Box
              sx={{
                position: "absolute",
                right: 40,
                top: 30,
                zIndex: 3,
                cursor: "pointer",
                "&:hover": {
                  "svg > g > g > path": {
                    stroke: "#a2a2a2",
                  },
                  "svg > g > g > circle": {
                    stroke: "#a2a2a2",
                  },
                },
              }}
              onClick={(e) => {
                setPopupImages(true);
                e.preventDefault();
              }}
            >
              <Gallery style={{ width: 24, color: "#d2d2d2" }} />
            </Box>
          </Tooltip>

          <PopupImages
            id={id}
            open={popupImages}
            close={() => setPopupImages(false)}
            data={images}
            imageDefault={imagedefault?.length > 0 ? imagedefault : ""}
            colorComponentName="orderDetailsPopupReorderAndSwap"
            {...{ rotationdefault }}
          />

          <Flex width={1} p={2} bg={"white"} flexDirection={"column"}>
            <Flex
              width={1}
              justifyContent={"center"}
              justifySelf="center"
              bg={"white"}
              color="black"
              style={{
                borderTop: "1px solid gray",
                borderBottom: "1px solid gray",
              }}
            >
              {getLocalizedString("COLORS AVAILABILITY")}
            </Flex>
            <Flex
              width={1}
              flexDirection={["column", "row"]}
              justifyContent="left"
              alignItems={"center"}
              flexWrap={"wrap"}
            >
              {calculatedColors().map((e, i) => {
                const isSelected =
                  totalQuantityColorMap?.[e.code] ||
                  sessionAddedColors.includes(e.code);
                return (
                  <Box
                    key={`color-selectors-${i}`}
                    sx={{
                      width: ["calc(100% / 3)", , , "50%"],
                      cursor: isSelected ? "default" : "pointer",
                    }}
                    onClick={() => {
                      if (!isSelected) {
                        forceColorVisibility(e.code);
                      }
                    }}
                  >
                    <ColorTooltip
                      productId={id}
                      code={e.code}
                      colorDescription={e.colorDescription}
                      rgb={e.rgb}
                      componentName={"orderDetailsProductReorderAndSwap"}
                      type={"SWAP"}
                    />
                  </Box>
                );
              })}
            </Flex>
          </Flex>

          {!isTablet && <Flex height="30px" bg={"white"}></Flex>}
        </Box>
        {isTablet && (
          <OrderDetailInfo
            {...{
              expand,
              modelCode,
              collectionCode,
              configuration,
              order,
              collection,
              line,
            }}
          />
        )}
      </Box>
      {/* END - PRODUCT IMAGE & COLORS */}
      {/* SELECTED COLORS */}
      <Box
        sx={{
          position: "relative",
          flex: 1,
          width: ["100%", , , "unset"],
          paddingTop: ["15px", , , "25px"],
          paddingBottom: [0, , , "25px"],
          paddingRight: [0, , , "16.8585px"],
          marginLeft: [0, , , "-10px"],
        }}
        pl={0}
      >
        {isDesktop && (
          <OrderDetailInfo
            {...{
              expand,
              modelCode,
              collectionCode,
              configuration,
              order,
              collection,
              line,
            }}
          />
        )}
        {/* COLOR GRIDS */}
        {sortColors(calculatedColors())?.map((e, index) => {
          return (
            <Box
              key={index}
              width={"100%"}
              p={2}
              minHeight={["330px", "0px"]}
              sx={{
                position: "relative",
                mx: [0, , "15px", 0],
                marginBottom: 3,
                display:
                  (totalQuantityColorMap &&
                    totalQuantityColorMap[e.code] > 0) ||
                  forceVisible[e.code]
                    ? ""
                    : "none",
              }}
              bg="white"
            >
              <Flex width={"100%"} overflowX={"auto"}>
                <Box
                  bg="white"
                  width={"100%"}
                  sx={{
                    display: "grid",
                    gridGap: 0,
                    flex: 1,
                    gridTemplateColumns:
                      "100px 120px " +
                      e.values.map((v) => "1fr ").join("") +
                      "50px 100px",
                  }}
                >
                  {/* ROW 1 */}
                  <Box
                    style={{
                      border: "1px solid #E0E0E0",
                      borderTop: 0,
                      borderBottom: 0,
                      borderLeft: 0,
                      textAlign: "center",
                      display: "flex",
                      justifyContent: "center",
                      width: "100%",
                      alignItems: "center",
                      minHeight: "35px",
                      fontSize: "12px",
                      background: "#fff",
                      position: "sticky",
                      left: 0,
                      zIndex: 1,
                    }}
                    w={1}
                  >
                    {getLocalizedString("COLOR")}
                  </Box>
                  <Box
                    style={{
                      border: "1px solid #E0E0E0",
                      borderTop: 0,
                      borderBottom: 0,
                      borderLeft: 0,
                      textAlign: "center",
                      display: "flex",
                      justifyContent: "center",
                      width: "100%",
                      alignItems: "center",
                      fontSize: "12px",
                      background: "#fff",
                      position: "sticky",
                      left: "100px",
                      zIndex: 1,
                      textDecoration: buttonTableView ? "underline" : "none",
                      cursor: buttonTableView ? "pointer" : "default",
                    }}
                    onClick={buttonTableView ? changeTableView : null}
                  >
                    <HangerBG
                      style={{
                        paddingRight: "10px",
                      }}
                    />
                    {getLocalizedString("SIZE")}
                  </Box>
                  {e.values.sort(sizeSort).map((e1, idx) => (
                    <Box
                      style={{
                        border: "1px solid #E0E0E0",
                        borderTop: 0,
                        borderLeft: 0,
                        borderBottom: 0,
                        textAlign: "center",
                        borderRight:
                          e.values.length - 1 == idx ? 0 : "1px solid #E0E0E0",
                        display: "flex",
                        justifyContent: "center",
                        alignContent: "center",
                        minWidth: "20px",
                      }}
                      color={"black"}
                      fontWeight="bold"
                      key={idx}
                    >
                      <Flex
                        style={{
                          display: "grid",
                          justifyContent: "center",
                          alignContent: "center",
                        }}
                      >
                        {e1.size}
                      </Flex>
                    </Box>
                  ))}
                  <Box
                    style={{
                      textAlign: "center",
                      borderBottom: "1px solid #F2F2F2",
                    }}
                  ></Box>
                  <Box
                    style={{
                      textAlign: "center",
                      borderBottom: "1px solid #F2F2F2",
                    }}
                  ></Box>
                  {/* END - ROW 1 */}
                  {/* ROW 2 */}
                  <Box
                    style={{
                      textAlign: "center",
                      border: "1px solid #E0E0E0",
                      borderLeft: 0,
                      borderBottom: 0,
                      gridRow:
                        "span " +
                        (order && order?.customData?.doors?.length + 1),
                      background: "#fff",
                      position: "sticky",
                      left: 0,
                      zIndex: 1,
                    }}
                  >
                    <Box
                      style={{
                        fontWeight: "bold",
                        paddingTop: "7px",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                      }}
                    >
                      {e.colorDescription.toUpperCase()}
                    </Box>
                    <ColorTooltip
                      id={id}
                      code={e.code}
                      colorDescription={e.colorDescription}
                      rgb={e.rgb}
                      componentName={"orderDetailsGrillReorderAndSwap"}
                      type={"SWAP"}
                      enableMobileTooltip
                    />
                  </Box>
                  <Box
                    style={{
                      textAlign: "center",
                      border: "1px solid #E0E0E0",
                      borderLeft: 0,
                      borderBottom: "1px solid #E0E0E0",
                      display: "flex",
                      justifyContent: "center",
                      width: "100%",
                      alignItems: "center",
                      minHeight: "35px",
                      color: "#666666",
                      fontSize: "12px",
                      background: "#fff",
                      position: "sticky",
                      left: "100px",
                      zIndex: 1,
                    }}
                  >
                    {getLocalizedString("AVAILABILITY_SWAP")}
                  </Box>

                  {e.values.sort(sizeSort).map((e1, idx) => (
                    <Box
                      color={"white"}
                      style={{
                        textAlign: "center",
                        border: "1px solid #E0E0E0",
                        borderTop: 0,
                        borderLeft: 0,
                        display: "flex",
                        justifyContent: "center",
                        width: "100%",
                        alignItems: "center",
                      }}
                      bg={
                        e1.quantity > 0
                          ? availabilityColorsMap["green"]
                          : availabilityColorsMap["red"]
                      }
                      key={idx}
                    >
                      {e1.quantity}
                    </Box>
                  ))}

                  <Box
                    style={{
                      borderBottom: "1px solid #E0E0E0",
                      textAlign: "center",
                      display: "flex",
                      justifyContent: "center",
                      width: "100%",
                      alignItems: "center",
                      fontSize: "12px",
                    }}
                    bg={"#646464"}
                    color={"white"}
                  >
                    {getLocalizedString("QTA")}
                  </Box>
                  <Box
                    style={{
                      border: "1px solid #E0E0E0",
                      borderTop: 0,
                      textAlign: "center",
                      display: "flex",
                      justifyContent: "left",
                      width: "100%",
                      alignItems: "center",
                      paddingLeft: "20px",
                    }}
                    bg={"#646464"}
                    color={"white"}
                  >
                    {customer?.currencySymbol}
                  </Box>
                  {/* END - ROW 2 */}
                  {/* DOORS */}
                  {order?.customData?.doors?.map((doorId, idx) => (
                    <AvailabilityGridDoor
                      key={`door-${idx}-${doorId}`}
                      doorId={doorId}
                      color={e}
                      productId={id}
                      orderType={config.ORDER_TYPE_SWAP}
                    />
                  ))}
                  {/* END - DOORS */}
                  {/* COLOR TOTALS */}

                  <Box></Box>
                  <Box></Box>
                  {e.values.sort(sizeSort).map((e1, idx) => (
                    <Box key={idx}></Box>
                  ))}
                  <Box
                    style={{
                      fontWeight: "bold",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      marginTop: "10px",
                    }}
                  >
                    {totalQuantityC[e.code] || 0}
                  </Box>
                  <Box
                    style={{
                      fontWeight: "bold",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      marginTop: "10px",
                    }}
                  >
                    <Price price={totalPriceC[e.code]}></Price>
                  </Box>
                  {/* END - COLOR TOTALS */}
                </Box>
              </Flex>
              <Tooltip content={getLocalizedString("ORDER_DELETE_ITEM_COLOR")}>
                <Box
                  sx={{
                    cursor: "pointer",
                    position: "absolute",
                    right: "12px",
                    top: "10px",
                  }}
                  onClick={() => {
                    setColorCode(e.code);
                    setMModelCode(modelCode);
                    setDeleteMessage(
                      getLocalizedString("DELETEORDER_ITEM_MESSAGE") +
                        modelCode +
                        "(" +
                        e.code +
                        ") ?",
                    );
                    setRemoveProduct(false);
                  }}
                >
                  <Close style={{ width: "16px", height: "16px" }} />
                </Box>
              </Tooltip>
            </Box>
          );
        })}
        {/* END - COLOR GRIDS */}
        <OrderDetailTotal
          {...{ customer, totalQuantity, totalPrice }}
          sx={{
            margin: [0, , "0 15px 15px", 0],
          }}
        />
      </Box>
      {/* BUTTONS */}
      <Box
        onClick={expand}
        sx={{ "& > svg > g > g > line": { stroke: "white" } }}
        style={{
          cursor: "pointer",
          position: "absolute",
          right: "15px",
          top: "10px",
          backgroundColor: "#ff9900",
        }}
      >
        {expanded == true && (
          <Tooltip content={getLocalizedString("ORDER_COLLAPSE_ROW")}>
            <Box bg="#f2f2f2" style={{ position: "absolute", right: "40px" }}>
              <ChevronDown
                className="checvron.exp_true"
                style={{ transform: "rotate(180deg)", width: 24, height: 24 }}
              />
            </Box>
          </Tooltip>
        )}

        {expanded == false && (
          <Tooltip content={getLocalizedString("ORDER_EXPAND_ROW")}>
            <Box bg="#f2f2f2" style={{ position: "absolute", right: "40px" }}>
              <ChevronDown
                className="checvron.exp_false"
                style={{ transform: "rotate(180deg)", width: 24, height: 24 }}
              />
            </Box>
          </Tooltip>
        )}
      </Box>
      <Tooltip content={getLocalizedString("ORDER_DELETE_ITEM")}>
        <Box
          sx={{ "& > svg > g > g > line": { stroke: "white" } }}
          style={{
            cursor: "pointer",
            position: "absolute",
            right: "15px",
            top: "10px",
            backgroundColor: "#232323",
            zIndex: 1,
          }}
          onClick={() => {
            setMModelCode(modelCode);
            setDeleteMessage(
              getLocalizedString("DELETEORDER_ITEM_MESSAGE") + modelCode + " ?",
            );
            setRemoveProduct(true);
          }}
        >
          <Close style={{ width: 24, height: 24 }}></Close>
        </Box>
      </Tooltip>
      {tableView && <TableSize onClose={changeTableView} />}
      {/* END - BUTTONS */}
    </Flex>
  );
};

export { OrderDetailSwap };
